import React, { useRef } from 'react'
import styles from './Phase4.module.css'

import Image from '../../components/Image/Image'
import IconVolume from '../../../../../assets/icons/IconVolume'
import IconMale from '../../../../../assets/icons/IconMale'
import IconFemale from '../../../../../assets/icons/IconFemale'

import { getSoundDownloadUrl } from '../../components/Sound/Sound'

const CardWord = ({
    word,
    onCardClick,
}) => {
    return (
        <div
            onClick={onCardClick}
            className={styles.wordContainer}>
            <div className={styles.wordContainerUpper}>
                <IconVolume size={24} />
                <Image
                    imagePath={word.img_path}
                    size={'80%'} />
                {
                    word.gender === 'Male' ? <IconMale size={24} /> :
                        word.gender === 'Female' ? <IconFemale size={24} /> :
                            word.gender === 'Both' ?
                                <div style={{display:'flex', flexDirection: 'column',}}>
                                    <IconMale size={24} />
                                    <div style={{ height: '8px' }}/>
                                    <IconFemale size={24} />
                                </div> :
                                <div style={{ width: '24px' }} />
                }
            </div>
            <p className={styles.wordHebrew}>{word.vow}</p>
            <p className={styles.wordEnglish}>{word.eng}</p>
        </div>
    )
}


const Phase4 = ({
    words,
    onNextPhase,
}) => {

    const mediaPlayer = useRef(new Audio())

    const playSound = (word) => {
        getSoundDownloadUrl(word.sound_path).then((url) => {
            mediaPlayer.current.pause();
            mediaPlayer.current.src = url;
            mediaPlayer.current.play();
        })
    }

    return (
        <div className={styles.container}>
            {
                words.map((word, index) => {
                    return (
                        <CardWord
                            key={String(index)}
                            word={word}
                            onCardClick={() => playSound(word)} />
                    )
                })
            }
            <div
                className={styles.bottomButton}
                onClick={() => onNextPhase()}>
                <p className={styles.bottomButtonTitle}>Finish</p>
            </div>
        </div>
    )
}

export default Phase4
